import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { UtilsService } from '../../../shared/services/utils.service';
import { environment } from '../../../environments/environment';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-gem',
  standalone: true,
  imports: [],
  templateUrl: './gem.component.html',
  styleUrl: './gem.component.scss'
})
export class GemComponent implements OnInit {
  environment: any = environment;
  constructor(public utils: UtilsService, private metaSvc: MetaMgmtService) {
    let metaData: any = {
      canonicalURL: 'https://www.luminousindia.com/sub-category/gem',
      description: 'Empowering our partners with GeM portal assistance online. Be in touch with us and get the complete info.',
      pageTitle: 'Empowering Our Partners With GeM Portal Assistance | Luminous India'
    }
    this.metaSvc.updateMetaTags(metaData);
  }

  ngOnInit(): void {
    this.utils.showLoading();
  }

  viewPDF(url: string) {
    window.open(url, '_blank');
  }

  imageLoaded() {
    this.utils.hideLoading();
  }

}
